import { domainSteps } from "@/mocks/home";

export default function DomainSection() {
  return (
    <section id="domain" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                <i className="ri-shield-star-line"></i>
                防走失方案
              </span>
              <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
                域名失效了怎么办
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                网址打不开通常只是临时问题，按以下四步排查，绝大多数情况都能自行解决。
                把这套方法记下来，就等于给自己上了一份「防走失保险」。
              </p>
            </div>
            <div className="rounded-lg bg-background-50 border border-background-200/70 px-5 py-4 flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-lightbulb-flash-line text-xl"></i>
              </span>
              <p className="text-sm text-foreground-700">
                核心原则：<strong className="font-semibold text-foreground-950">收藏本页</strong>，地址变化都能找回。
              </p>
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {domainSteps.map((step, idx) => (
              <div
                key={step.title}
                className="relative rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 h-full"
              >
                <span className="absolute top-5 right-5 font-heading text-3xl font-bold text-background-200">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <span className="w-11 h-11 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-lg bg-primary-950 px-5 py-6 md:px-8 md:py-8">
            <div className="flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
              <span className="w-14 h-14 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center animate-float-slow">
                <i className="ri-anchor-line text-2xl"></i>
              </span>
              <div className="flex-1">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50">
                  永久域名建议
                </h3>
                <p className="mt-2 text-sm text-background-100/85 leading-relaxed">
                  与其记住随时可能变化的观看地址，不如固定记住本站这个入口页。
                  把本页当作你的「锚点」，无论地址如何更换，都从这里出发重新找到最新入口。
                </p>
              </div>
              <a
                href="#address"
                className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-up-line"></i>
                回到最新地址
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}